var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardMdiCarInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7879 9.35905L19.697 13.5882H10.0304L11.7462 9.35905H17.7879ZM11.2387 14.7965C10.5741 14.7965 10.0304 15.3403 10.0304 16.0049C10.0304 16.6695 10.5741 17.2132 11.2387 17.2132C11.9033 17.2132 12.447 16.6695 12.447 16.0049C12.447 15.3403 11.9033 14.7965 11.2387 14.7965ZM18.4887 14.7965C17.8241 14.7965 17.2804 15.3403 17.2804 16.0049C17.2804 16.6695 17.8241 17.2132 18.4887 17.2132C19.1533 17.2132 19.697 16.6695 19.697 16.0049C19.697 15.3403 19.1533 14.7965 18.4887 14.7965ZM25.7387 6.33822V13.5882C25.7387 20.2945 21.0987 26.5657 14.8637 28.0882C8.62871 26.5657 3.98871 20.2945 3.98871 13.5882V6.33822L14.8637 1.50488L25.7387 6.33822ZM22.1137 14.7965L19.5037 8.75488C19.262 8.05405 18.5854 7.54655 17.7879 7.54655H11.7462C10.9487 7.54655 10.272 8.05405 10.0304 8.75488L7.61371 14.7965V19.6299C7.61371 20.2945 8.15746 20.8382 8.82204 20.8382H10.0304C10.695 20.8382 11.2387 20.2945 11.2387 19.6299V18.4216H18.4887V19.6299C18.4887 20.2945 19.0325 20.8382 19.697 20.8382H20.9054C21.57 20.8382 22.1137 20.2945 22.1137 19.6299V14.7965Z",
    fill: "#66BCFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMdiCarInsurance);
export default __webpack_public_path__ + "static/media/dashboard_mdi_car_insurance.70101600e3f08a84fc4c2993a6152cfa.svg";
export { ForwardRef as ReactComponent };